module.exports = __webpack_public_path__ + "img/log-1.15264467.png";